import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lightbulb, Send } from "lucide-react";
import { api } from "@/lib/api";

export function AdminMemberTip() {
  const [text, setText] = useState(null);
  const [saved, setSaved] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings").then((r) => { setText(r.data.member_tip || ""); setSaved(r.data.member_tip || ""); }).catch(() => {}); }, []);
  if (text === null) return null;
  const save = async () => {
    const fd = new FormData(); fd.append("member_tip", text);
    try { const r = await api.put("/admin/settings", fd); setText(r.data.member_tip); setSaved(r.data.member_tip); toast.success("Tip saved — it goes out in the next monthly check-in"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
  };
  const preview = async () => {
    setBusy(true);
    try { const r = await api.post("/admin/memberships/checkin-preview", new FormData()); toast.success(`Preview sent to ${r.data.to}`); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not send preview"); }
    finally { setBusy(false); }
  };
  return (
    <div className="dg-card rounded-xl p-5" data-testid="admin-member-tip">
      <div className="dg-eyebrow flex items-center gap-1"><Lightbulb className="w-3 h-3" /> Monthly member check-in · tip of the month</div>
      <p className="text-sm text-slate-400 mt-2">On the 1st of every month at 10 AM, active members get a friendly "anything acting up?" email with one-tap Ask / Book buttons (Care+ members are reminded their included session is ready) and this tip. Change it whenever you like.</p>
      <textarea className="dg-input mt-3 min-h-[110px] text-sm" value={text} onChange={(e) => setText(e.target.value)} maxLength={1200} data-testid="member-tip-input" />
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <button type="button" onClick={save} disabled={text === saved} className="dg-btn-primary rounded-full px-5 py-2 text-sm disabled:opacity-40" data-testid="member-tip-save">Save tip</button>
        <button type="button" onClick={preview} disabled={busy} className="dg-btn-ghost rounded-full px-5 py-2 text-sm flex items-center gap-2 disabled:opacity-40" data-testid="member-tip-preview"><Send className="w-3 h-3" /> {busy ? "Sending…" : "Email me a preview"}</button>
        <span className="text-xs text-slate-500">{text.length}/1200</span>
      </div>
    </div>
  );
}
